// extracted by mini-css-extract-plugin
export default {"box":"Loadbar_box__9r-sZ","content":"Loadbar_content__imfCk","percent":"Loadbar_percent__iPAeZ","dot":"Loadbar_dot__Kkfom","animateDot":"Loadbar_animateDot__X889f"};